var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1239_2232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0.625C9.29688 0.625 0.625 9.29688 0.625 20C0.625 30.7031 9.29688 39.375 20 39.375C30.7031 39.375 39.375 30.7031 39.375 20C39.375 9.29688 30.7031 0.625 20 0.625ZM26.25 13.75C27.6328 13.75 28.75 14.8672 28.75 16.25C28.75 17.6328 27.6328 18.75 26.25 18.75C24.8672 18.75 23.75 17.6328 23.75 16.25C23.75 14.8672 24.8672 13.75 26.25 13.75ZM13.75 13.75C15.1328 13.75 16.25 14.8672 16.25 16.25C16.25 17.6328 15.1328 18.75 13.75 18.75C12.3672 18.75 11.25 17.6328 11.25 16.25C11.25 14.8672 12.3672 13.75 13.75 13.75ZM28.9688 27.0469C26.7422 29.7188 23.4766 31.25 20 31.25C16.5234 31.25 13.2578 29.7188 11.0312 27.0469C9.96875 25.7734 11.8906 24.1797 12.9531 25.4453C14.7031 27.5469 17.2656 28.7422 20 28.7422C22.7344 28.7422 25.2969 27.5391 27.0469 25.4453C28.0938 24.1797 30.0234 25.7734 28.9688 27.0469Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1239_2232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.661c351b803a81ca0baca5426a253103.svg";
export { ForwardRef as ReactComponent };